__turbopack_context__.v({
  "blocksBackgroundColor": "Gallerypage-module-scss-module__dVHkMG__blocksBackgroundColor",
  "blocksFontColor": "Gallerypage-module-scss-module__dVHkMG__blocksFontColor",
  "container": "Gallerypage-module-scss-module__dVHkMG__container",
  "content": "Gallerypage-module-scss-module__dVHkMG__content",
  "editButton": "Gallerypage-module-scss-module__dVHkMG__editButton",
  "galleryItem": "Gallerypage-module-scss-module__dVHkMG__galleryItem",
  "mediaItem": "Gallerypage-module-scss-module__dVHkMG__mediaItem",
  "mediaItemHidden": "Gallerypage-module-scss-module__dVHkMG__mediaItemHidden",
  "secondaryNavBackgroundColor": "Gallerypage-module-scss-module__dVHkMG__secondaryNavBackgroundColor",
  "themeBackgroundColor": "Gallerypage-module-scss-module__dVHkMG__themeBackgroundColor",
  "themeFontColor": "Gallerypage-module-scss-module__dVHkMG__themeFontColor",
  "transitionEnter": "Gallerypage-module-scss-module__dVHkMG__transitionEnter",
  "transitionEnterActive": "Gallerypage-module-scss-module__dVHkMG__transitionEnterActive",
  "transitionEnterDone": "Gallerypage-module-scss-module__dVHkMG__transitionEnterDone",
  "transitionExit": "Gallerypage-module-scss-module__dVHkMG__transitionExit",
  "transitionExitActive": "Gallerypage-module-scss-module__dVHkMG__transitionExitActive",
  "transitionExitDone": "Gallerypage-module-scss-module__dVHkMG__transitionExitDone",
});
